import { useEffect } from "react";
import {
  Autocomplete,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useOrgDashboardStore } from "../../../stores/orgDashboardStore";
import { useEventManagementStore } from "@/stores/eventManagementStore";

export const OrganizationAutocomplete = () => {
  const {
    organizations,
    fetchOrganizations,
    selectedOrganization,
    setSelectedOrganization,
  } = useOrgDashboardStore();
  const { setSelectedTrainingOrganization } = useEventManagementStore();

  const theme = useTheme();
  const isViewportMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  return (
    <Autocomplete
      id={"organization-auto-select"}
      data-cy="selectOrganization"
      getOptionLabel={(option) => option.name}
      options={organizations}
      value={selectedOrganization}
      onChange={(_, newValue) => {
        setSelectedOrganization(newValue);
        setSelectedTrainingOrganization(null);
      }}
      fullWidth
      clearIcon={null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Select Organization"}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            sx: isViewportMediumOrLarger
              ? {
                  color: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:focus .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                }
              : {},
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: isViewportMediumOrLarger ? { color: "white" } : {},
          }}
        />
      )}
      sx={
        isViewportMediumOrLarger
          ? {
              color: "white",
              "& .MuiAutocomplete-option": {
                color: "black",
                "&:hover": { color: "white" },
              },
              "& .MuiAutocomplete-input": { color: "white" },
              "& .MuiSvgIcon-root": {
                color: "white",
                "&:hover": { color: "white" },
              },
            }
          : {}
      }
    />
  );
};
